window.app_models.vacate_notice = {
    "id":null,
    "move_in_date":null,
    "move_out_date":null,
    "confirmed":null,
    "confirmation_date":null,
    "note":null,
    "property_id":null,
    "grace_period":window.app_models.option,
    "property":window.app_models.property
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/vacate_notice.js